<template>
  <App>
    <div class="d-flex flex-column flex-xl-row">
      <!--begin::Sidebar-->
      <div class="flex-column flex-lg-row-auto w-100 w-xl-350px mb-10">
        <!--begin::Card-->
        <div class="card mb-5 mb-xl-8">
          <!--begin::Card body-->
          <div class="card-body">
            <div id="kt_customer_view_details" class="collapse show">
              <div class="fs-6">
                <div class="fw-bolder">Projeto</div>
                <div class="text-gray-600">{{avaliacao.projeto.nome}}</div>

                <div class="fw-bolder mt-5">Categoria</div>
                <div class="text-gray-600">{{avaliacao.projeto.categoria.nome}}</div>

                <div class="fw-bolder mt-5">Alunos</div>
                <div class="text-gray-600">
                  <p class="text-gray-600 text-hover-primary" v-for="aluno in avaliacao.projeto.alunos">{{aluno.nome}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-5 mb-xl-8" v-if="avaliacao.situacao === 2">
          <!--begin::Card body-->
          <div class="card-body">
            <div class="collapse show">
              <div class="fs-6">
                <div class="fw-bolder">Sua avaliação</div>
                <div class="text-gray-600" v-html="avaliacao.avaliacao_projeto.observacoes.replaceAll('\n', '</br>')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Sidebar-->
      <!--begin::Content-->
      <div class="flex-lg-row-fluid ms-lg-15">
        <form-body :loading="form.processing" :form="form" hideSubmitButton>
          <div class="mb-10">
            <h2 class="mb-7">Questão Problema</h2>
            <p class="text-gray-600 mb-5" v-html="avaliacao.projeto.questao.replaceAll('\n', '</br>')"></p>
          </div>

          <div class="mb-10">
            <h2 class="mb-7">Introdução</h2>
            <p class="text-gray-600 mb-5" v-html="avaliacao.projeto.introducao.replaceAll('\n', '</br>')"></p>
          </div>

          <div class="mb-10">
            <h2 class="mb-7">Abordagem teórica</h2>
            <p class="text-gray-600 mb-5" v-html="avaliacao.projeto.abordagem.replaceAll('\n', '</br>')"></p>
          </div>

          <div class="mb-10">
            <h2 class="mb-7">Referências</h2>
            <p class="text-gray-600 mb-5" v-html="avaliacao.projeto.referencia.replaceAll('\n', '</br>')"></p>
          </div>

          <div class="mb-10">
            <h2>Sua avaliação</h2>
            <p class="text-gray-600 fs-5">Adicione o máximo de informações para o avaliação do projeto.</p>
          </div>

          <div class="row" v-if="avaliacao.situacao === 0 || avaliacao.situacao === 2">
            <div class="col-3 mb-3">
              <form-group label="Situação">
                <select v-model="form.situacao" class="form-control">
                  <option value="-1" disabled="disabled">Selecione uma opção</option>
                  <option value="3">Aprovado</option>
                  <option value="4" :disabled="avaliacao.situacao !== 2">Reprovado</option>
                  <option value="1" :disabled="avaliacao.situacao !== 0">Aprovado com reformulações</option>
                </select>
              </form-group>
            </div>

            <div class="col-12 mb-3" v-if="avaliacao.situacao !== 2">
              <form-group label="Sua avaliação">
                <textarea placeholder="Sua avaliação" v-model="form.observacoes" rows="5" class="form-control"></textarea>
              </form-group>
            </div>
          </div>
          <button @click="enviarAvaliacao"
                  v-if="avaliacao.situacao === 0 || avaliacao.situacao === 2"
                  :disabled="form.situacao < 0" class="btn btn-success mt-3">
            Enviar
          </button>
        </form-body>
      </div>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";

export default {
  props: ['avaliacao'],

  components: {
    FormGroup,
    FormBody,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  setup(props) {
    const form = useForm({
      id: props.avaliacao.id,
      observacoes: null,
      situacao: -1
    })
    return {form};
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Avaliação de Projeto');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Avaliação', link: 'app.projetos.avaliar'},
        {title: 'Avalia Projeto'},
      ]);

      this.emitter.emit('action', {
            show: true,
            icon: 'bi-arrow-left-short',
            title: 'Voltar',
            link: this.route('app.projetos.avaliar')
          }
      );
    },

    enviarAvaliacao() {
      this.emitter.emit('alert', {
        title: 'Confirma a ação?',
        text: 'Tem certeza que deseja enviar sua avaliação?',
        icon: 'warning',
        success: this.envia
      })
    },

    envia() {
      this.form.processing = true
      this.form.post(this.route('app.projetos.envia-avaliacao-projeto', {'projetoAvaliadorId': this.form.id}))
    }
  },
};
</script>
